export const buildSliderValues = ({ price, min, max, botHeadValue }) => {
  return [min, price, botHeadValue, max].sort((a, b) => a - b)
}

export const hijackSliderValues = ({
  markerValues, // slider markers, min, max - anywhere a marker may be
  allSpecialValues, // all marker values plus min and max
  interval, // increments
  sliderValue, // current slider value
  roundValue = false,
}) => {
  const satisfiesCondition = markerValues.map(
    (value) =>
      (sliderValue + interval > value && sliderValue <= value) ||
      (sliderValue - interval < value && sliderValue >= value)
  )

  if (satisfiesCondition.includes(true)) {
    let selectedArrayValue = sliderValue
    let diff = null

    allSpecialValues.forEach((value) => {
      const currentDiff = Math.abs(value - sliderValue)

      if (!diff || currentDiff < diff) {
        diff = currentDiff
        selectedArrayValue = value
      }
    })
    return selectedArrayValue
  } else {
    if (roundValue) {
      return Math.round(sliderValue / interval) * interval
    }
    return sliderValue
  }
}
